// extracted by mini-css-extract-plugin
export default {"tableHeader":"table-header_tableHeader__CVlRk","tableHeaderCell":"table-header_tableHeaderCell__7Gx6x"};